module.exports = __webpack_public_path__ + "img/bj.675537f4.png";